import { render, staticRenderFns } from "./FormOrganisationTypeLocale.vue?vue&type=template&id=b843f0aa&scoped=true&"
import script from "./FormOrganisationTypeLocale.vue?vue&type=script&lang=js&"
export * from "./FormOrganisationTypeLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b843f0aa",
  null
  
)

export default component.exports